(function(angular){
    'use strict';

    var inject = [
        '$scope',
        '$window',
        '$location',
        '$translate',
        '$state',
        '$stateParams',
        '$timeout',
        '$q',
        'dmsAccess'
    ];

    var searchMasterCtl = function(
        $scope: any,
        $window: any,
        $location: any,
        $translate: any,
        $state: any,
        $stateParams: any,
        $timeout: any,
        $q: any,
        dmsAccess: any) {

        function createAllDocumentsPath() {
            return $translate('Onvio.Shell.Navigation.Documents').then(function(s: any){
                var item = {
                    icon: 'all-docs',
                    href: $state.href('allDocsRootList'),
                    text: s,
                };
                return item;
            });
        }

        async function createDocumentActivityPath() {
            const pathText = await $translate('Bluemoon.DMS.SpecialFolders.DocumentActivity');
            const item = {
                icon: 'all-docs',
                href: $state.href('recentsList'),
                text: pathText,
            };
            return item;
        }

        function createClientDocumentsPath() {
            var translations = {
                clientDocuments: $translate('Onvio.Shell.Navigation.ClientDocuments'),
                clientOnly: $translate('Bluemoon.DMS.Search.ClientOnly')
            };

            return $q.all(translations).then(function(strings: any) {
                var text = strings.clientDocuments;
                if ($stateParams.includeDocuments === 'false') {
                    text += ' (' + strings.clientOnly + ')';
                }

                var item = {
                    container: {
                        id: 'Client',
                        name: text,
                        isClientBranch: true,
                        itemType: 'ClientRoot'
                    },
                    href: $state.href('clientRootList'),
                    icon: 'client',
                    text: text,
                };
                return item;
            });
        }

        function createTemplatesPath() {
            return $translate('Bluemoon.DMS.SpecialFolders.Templates').then(function(s: any){
                var item = {
                    container: {
                        id: 'Templates',
                        name: s,
                        isTemplateBranch: true,
                        itemType: 'TemplateRoot'
                    },
                    href: $state.href('templateList'),
                    icon: 'templates',
                    text: s
                };
                return item;
            });
        }

        if ($stateParams.containerType) {
            $scope.containerId = $stateParams.containerId;
            $scope.containerType = $stateParams.containerType;
        }

        $scope.breadcrumbPathCallback = async function(path: any) {
            if (!$scope.containerType) {
                if (await dmsAccess.has('DMS_HideDocumentActivity')) {
                    const allDocsPath = await createAllDocumentsPath();
                    path.unshift(allDocsPath);
                } else {
                    const docActivityPath = await createDocumentActivityPath();
                    path.unshift(docActivityPath);
                }
            } else if ($scope.containerType === 'ClientsList') {
                createClientDocumentsPath().then(function(res: any) {
                    path.unshift(res);
                });
            } else if ($scope.containerType === 'TemplatesList') {
                createTemplatesPath().then(function(res: any) {
                    path.unshift(res);
                });
            }
        };
        //to inform main-controller.js to update page title when Search Results page is loaded
        $timeout(function() {
            $scope.$emit('pageTitleUpdate', {
                itemType: 'SearchList'
            });
        });

    };

    searchMasterCtl.$inject = inject;

    angular.module('onvio.documents').controller('searchMaster', searchMasterCtl);

})((window as any).angular);
